// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
import * as Specular_Components_Common from "../Specular.Components.Common/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var MDIcon = /* #__PURE__ */ (function () {
    function MDIcon(value0) {
        this.value0 = value0;
    };
    MDIcon.create = function (value0) {
        return new MDIcon(value0);
    };
    return MDIcon;
})();
var visibilityOff = /* #__PURE__ */ (function () {
    return new MDIcon("visibility_off");
})();
var visibility = /* #__PURE__ */ (function () {
    return new MDIcon("visibility");
})();
var undo = /* #__PURE__ */ (function () {
    return new MDIcon("undo");
})();
var timerOff = /* #__PURE__ */ (function () {
    return new MDIcon("timer_off");
})();
var takeoutDining = /* #__PURE__ */ (function () {
    return new MDIcon("takeout_dining");
})();
var star = /* #__PURE__ */ (function () {
    return new MDIcon("star");
})();
var showChart = /* #__PURE__ */ (function () {
    return new MDIcon("show_chart");
})();
var shoppingCart = /* #__PURE__ */ (function () {
    return new MDIcon("shopping_cart");
})();
var shoppingBasket = /* #__PURE__ */ (function () {
    return new MDIcon("shopping_basket");
})();
var settings = /* #__PURE__ */ (function () {
    return new MDIcon("settings");
})();
var separator = function (w) {
    return function (h) {
        return Specular_Dom_Element.rawHtml("<svg width=\"" + (show(w) + ("\" height=\"" + (show(h) + "\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M33.75 5C33.06 5 32.5 5.56 32.5 6.25V13.75H7.5V6.25C7.5 5.56 6.94 5 6.25 5C5.56 5 5 5.56 5 6.25V13.75C5 15.1287 6.12125 16.25 7.5 16.25H32.5C33.8787 16.25 35 15.1287 35 13.75V6.25C35 5.56 34.44 5 33.75 5Z\" fill=\"currentColor\"/><path d=\"M32.5 23.75H7.5C6.12125 23.75 5 24.8712 5 26.25V33.75C5 34.44 5.56 35 6.25 35C6.94 35 7.5 34.44 7.5 33.75V26.25H32.5V33.75C32.5 34.44 33.06 35 33.75 35C34.44 35 35 34.44 35 33.75V26.25C35 24.8712 33.8787 23.75 32.5 23.75Z\" fill=\"currentColor\"/><path d=\"M6.875 21.25H8.125C8.815 21.25 9.375 20.69 9.375 20C9.375 19.31 8.815 18.75 8.125 18.75H6.875C6.185 18.75 5.625 19.31 5.625 20C5.625 20.69 6.185 21.25 6.875 21.25Z\" fill=\"currentColor\"/><path d=\"M14.375 21.25C15.065 21.25 15.625 20.69 15.625 20C15.625 19.31 15.065 18.75 14.375 18.75H13.125C12.435 18.75 11.875 19.31 11.875 20C11.875 20.69 12.435 21.25 13.125 21.25H14.375Z\" fill=\"currentColor\"/><path d=\"M20.625 21.25C21.315 21.25 21.875 20.69 21.875 20C21.875 19.31 21.315 18.75 20.625 18.75H19.375C18.685 18.75 18.125 19.31 18.125 20C18.125 20.69 18.685 21.25 19.375 21.25H20.625Z\" fill=\"currentColor\"/><path d=\"M26.875 21.25C27.565 21.25 28.125 20.69 28.125 20C28.125 19.31 27.565 18.75 26.875 18.75H25.625C24.935 18.75 24.375 19.31 24.375 20C24.375 20.69 24.935 21.25 25.625 21.25H26.875Z\" fill=\"currentColor\"/><path d=\"M33.125 21.25C33.815 21.25 34.375 20.69 34.375 20C34.375 19.31 33.815 18.75 33.125 18.75H31.875C31.185 18.75 30.625 19.31 30.625 20C30.625 20.69 31.185 21.25 31.875 21.25H33.125Z\" fill=\"currentColor\"/></svg>"))));
    };
};
var sell = /* #__PURE__ */ (function () {
    return new MDIcon("sell");
})();
var select = /* #__PURE__ */ (function () {
    return new MDIcon("select");
})();
var search = /* #__PURE__ */ (function () {
    return new MDIcon("search");
})();
var removeShoppingCart = /* #__PURE__ */ (function () {
    return new MDIcon("remove_shopping_cart");
})();
var removeCircleOutline = /* #__PURE__ */ (function () {
    return new MDIcon("remove_circle_outline");
})();
var removeCircle = /* #__PURE__ */ (function () {
    return new MDIcon("remove_circle");
})();
var remove = /* #__PURE__ */ (function () {
    return new MDIcon("remove");
})();
var refresh = /* #__PURE__ */ (function () {
    return new MDIcon("refresh");
})();
var redo = /* #__PURE__ */ (function () {
    return new MDIcon("redo");
})();
var rateReview = /* #__PURE__ */ (function () {
    return new MDIcon("rate_review");
})();
var questionMark = /* #__PURE__ */ (function () {
    return new MDIcon("question_mark");
})();
var polyline = /* #__PURE__ */ (function () {
    return new MDIcon("polyline");
})();
var pointOfSale = /* #__PURE__ */ (function () {
    return new MDIcon("point_of_sale");
})();
var person = /* #__PURE__ */ (function () {
    return new MDIcon("person");
})();
var payments = /* #__PURE__ */ (function () {
    return new MDIcon("payments");
})();
var panTool = /* #__PURE__ */ (function () {
    return new MDIcon("pan_tool");
})();
var orderApprove = /* #__PURE__ */ (function () {
    return new MDIcon("order_approve");
})();
var openInFull = /* #__PURE__ */ (function () {
    return new MDIcon("open_in_full");
})();
var offlineBolt = /* #__PURE__ */ (function () {
    return new MDIcon("offline_bolt");
})();
var notifications = /* #__PURE__ */ (function () {
    return new MDIcon("notifications");
})();
var moreVert = /* #__PURE__ */ (function () {
    return new MDIcon("more_vert");
})();
var moped = /* #__PURE__ */ (function () {
    return new MDIcon("moped");
})();
var mobileOff = /* #__PURE__ */ (function () {
    return new MDIcon("mobile_off");
})();
var md48 = /* #__PURE__ */ Specular_Components_Common.classModifier("md-48");
var md36 = /* #__PURE__ */ Specular_Components_Common.classModifier("md-36");
var md24 = /* #__PURE__ */ Specular_Components_Common.classModifier("md-24");
var md18 = /* #__PURE__ */ Specular_Components_Common.classModifier("md-18");
var md14 = /* #__PURE__ */ Specular_Components_Common.classModifier("md-14");
var mail = /* #__PURE__ */ (function () {
    return new MDIcon("mail");
})();
var lockOpen = /* #__PURE__ */ (function () {
    return new MDIcon("lock_open");
})();
var localShipping = /* #__PURE__ */ (function () {
    return new MDIcon("local_shipping");
})();
var lightbulb = /* #__PURE__ */ (function () {
    return new MDIcon("lightbulb");
})();
var insertPhoto = /* #__PURE__ */ (function () {
    return new MDIcon("insert_photo");
})();
var info = /* #__PURE__ */ (function () {
    return new MDIcon("info");
})();
var incompleteCircle = /* #__PURE__ */ (function () {
    return new MDIcon("incomplete_circle");
})();
var house = /* #__PURE__ */ Specular_Dom_Element.rawHtml("<svg width=\"64\" height=\"64\" viewBox=\"0 0 64 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"64\" height=\"64\" rx=\"32\" fill=\"#E8E8EC\"/><g clip-path=\"url(#clip0_7589_11830)\"><path d=\"M33.3315 40H30.6648V37.3333H33.3315V40ZM27.9982 36V41.3333C27.9982 42.0666 28.5982 42.6666 29.3315 42.6666H34.6648C35.3982 42.6666 35.9982 42.0666 35.9982 41.3333V36C35.9982 35.2666 35.3982 34.6666 34.6648 34.6666H29.3315C28.5982 34.6666 27.9982 35.2666 27.9982 36ZM41.3315 28.4V22.6666C41.3315 21.9333 40.7315 21.3333 39.9982 21.3333H38.6648C37.9315 21.3333 37.3315 21.9333 37.3315 22.6666V24.8L32.8915 20.8C32.3848 20.3466 31.6115 20.3466 31.1048 20.8L19.9582 30.84C19.5048 31.24 19.7848 32 20.3982 32H22.1448C22.4782 32 22.7982 31.88 23.0382 31.6533L31.9982 23.5866L40.9448 31.6533C41.1982 31.88 41.5182 32 41.8382 32H43.5848C44.1982 32 44.4915 31.24 44.0248 30.84L41.3315 28.4Z\" fill=\"#6F6F76\"/></g><defs><clipPath id=\"clip0_7589_11830\"><rect width=\"32\" height=\"32\" fill=\"white\" transform=\"translate(16 16)\"/></clipPath></defs></svg>");
var homePin = /* #__PURE__ */ (function () {
    return new MDIcon("home_pin");
})();
var help = /* #__PURE__ */ (function () {
    return new MDIcon("help");
})();
var fullscreen = /* #__PURE__ */ (function () {
    return new MDIcon("fullscreen");
})();
var filter = /* #__PURE__ */ (function () {
    return new MDIcon("filter_alt");
})();
var fill = /* #__PURE__ */ Specular_Components_Common.classModifier("md-fill");
var exportNotes = /* #__PURE__ */ (function () {
    return new MDIcon("export_notes");
})();
var expandMore = /* #__PURE__ */ (function () {
    return new MDIcon("expand_more");
})();
var expandLess = /* #__PURE__ */ (function () {
    return new MDIcon("expand_less");
})();
var error = /* #__PURE__ */ (function () {
    return new MDIcon("error");
})();
var edit = /* #__PURE__ */ (function () {
    return new MDIcon("edit");
})();
var dragIndicator = /* #__PURE__ */ (function () {
    return new MDIcon("drag_indicator");
})();
var download = /* #__PURE__ */ (function () {
    return new MDIcon("download");
})();
var done = /* #__PURE__ */ (function () {
    return new MDIcon("done");
})();
var dividerSpecial = /* #__PURE__ */ Specular_Dom_Element.rawHtml("<svg width=\"168\" height=\"72\" viewBox=\"0 0 168 72\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M155.61 32.808C150.669 22.4069 132.46 17.2607 131.688 17.0499C131.624 17.028 131.564 17.0537 131.492 17.0499C131.432 17.0438 131.389 17.0401 131.324 17.0499C131.082 17.0695 130.854 17.1474 130.683 17.3226C130.515 17.4979 130.447 17.7254 130.432 17.9581C130.424 18.0238 130.432 18.0737 130.44 18.1371C130.452 18.2074 130.425 18.2686 130.452 18.3351C132.56 25.0665 132.513 28.7801 131.779 32.2844C129.795 42.0041 129.899 47.4676 136.019 50.3365C137.573 51.0694 139.062 51.4404 140.457 51.4404C141.485 51.4404 142.401 51.2447 143.203 50.9258C141.856 52.2443 140.163 53.1253 138.29 53.4358C132.209 54.4634 128.687 50.5193 122.99 43.5145C122.432 42.8375 121.905 42.0879 121.376 41.3785C121.655 41.4261 121.949 41.4941 122.236 41.4941C123.189 41.4941 124.172 41.2394 125.121 40.7219C127.587 39.3626 128.508 36.2466 127.153 33.7767C126.013 31.7049 123.391 30.9501 121.303 32.0797C119.547 33.0476 118.901 35.2674 119.862 37.0241C120.691 38.5224 122.595 39.0725 124.093 38.2519C124.476 38.0449 124.595 37.6263 124.531 37.2236C124.539 37.1956 124.579 37.1798 124.583 37.148C124.691 36.5141 124.268 35.9044 123.63 35.7971C123.08 35.7056 122.61 36.0479 122.403 36.5458C122.1 36.4861 121.81 36.3396 121.646 36.0358C121.223 35.2636 121.507 34.2867 122.272 33.8643C123.371 33.2712 124.743 33.6694 125.347 34.7529C126.16 36.2353 125.611 38.1076 124.12 38.9244C121.602 40.3025 119.658 38.7415 118.478 37.1873C118.359 37.0354 118.183 36.9833 118.023 36.9198C113.537 30.9289 108.21 24.9524 99.1137 24.9524C99.0095 24.9524 98.8863 24.9524 98.7866 24.9524C94.3876 25.0204 90.4194 26.833 87.6162 30.0525C86.232 31.6422 85.2377 33.5447 84.5524 35.5848C83.8875 33.2818 82.7655 31.1617 81.2211 29.3951C78.4142 26.1719 74.4497 24.3646 70.0432 24.295C60.7036 24.1356 55.3391 30.1945 50.814 36.2587C50.6462 36.326 50.4793 36.3736 50.3599 36.5254C49.1827 38.0796 47.2522 39.6535 44.718 38.267C43.2296 37.4465 42.678 35.5742 43.4804 34.0955C44.0766 33.0158 45.4487 32.6003 46.5586 33.2032C47.3255 33.6293 47.6179 34.6018 47.1903 35.3747C47.0263 35.6694 46.7498 35.8167 46.4271 35.8764C46.2201 35.383 45.7501 35.04 45.2076 35.1314C44.5699 35.2395 44.134 35.8484 44.2534 36.4824C44.2534 36.5179 44.2934 36.53 44.301 36.5617C44.2428 36.9682 44.3743 37.3823 44.7452 37.5855C46.2511 38.4144 48.1476 37.856 48.9689 36.3539C49.9269 34.5927 49.2877 32.3774 47.5242 31.411C45.4524 30.2791 42.8367 31.046 41.6776 33.114C40.3304 35.5764 41.253 38.6886 43.7177 40.0509C44.6636 40.5692 45.6481 40.8239 46.6024 40.8239C46.8895 40.8239 47.1857 40.7559 47.463 40.7083C46.9288 41.4253 46.3954 42.1711 45.8476 42.848C40.1514 49.8605 36.6236 53.7819 30.5436 52.7694C28.6705 52.4589 26.9818 51.5824 25.6407 50.2632C26.4355 50.582 27.3498 50.774 28.3781 50.774C29.7729 50.774 31.2629 50.4037 32.8171 49.6739C38.9372 46.805 39.0384 41.3429 37.0566 31.6225C36.3252 28.1137 36.2889 24.397 38.3811 17.6725C38.4113 17.6067 38.3811 17.541 38.3917 17.4775C38.4037 17.4118 38.4113 17.3619 38.4037 17.2985C38.3781 17.0612 38.3184 16.8361 38.1506 16.6608C37.9753 16.4817 37.7419 16.4077 37.5054 16.3835C37.4479 16.3797 37.4117 16.3835 37.3505 16.3835C37.2825 16.388 37.213 16.3623 37.1465 16.3835C36.3758 16.595 18.1628 21.7412 13.2259 32.1401C11.5924 35.581 11.5924 39.1986 13.2199 42.9123C13.8772 44.3939 16.1945 46.4506 18.83 46.4506C19.5969 46.4506 20.32 46.2715 21.009 45.9406C21.3475 47.4064 21.9437 48.8133 22.8005 50.06C24.5799 52.6062 27.2077 54.2798 30.2058 54.7777C37.7706 56.0486 42.2315 50.5178 47.4403 44.1348C48.6122 42.6924 49.7335 41.1548 50.8752 39.5968C55.6504 33.0702 60.5752 26.3343 69.7138 26.3343C69.8037 26.3343 69.9049 26.3343 69.9986 26.3343C71.6367 26.3577 73.1781 26.7129 74.631 27.2727C74.6469 27.2803 74.6469 27.3007 74.6544 27.3128C78.3998 30.4303 79.3103 34.0389 77.2045 37.4729C75.5815 40.1348 72.0885 40.9795 69.4289 39.3535C67.3934 38.0985 66.7474 35.4336 67.9926 33.4049C68.4331 32.6622 69.1463 32.1439 69.9911 31.9406C70.8358 31.7276 71.7228 31.8704 72.4557 32.3267C72.9658 32.638 73.2846 33.1171 73.4599 33.6437C73.2846 33.6157 73.101 33.5757 72.9181 33.5999C71.8604 33.7268 71.1267 34.6871 71.2446 35.7396C71.3715 36.7914 72.3424 37.5364 73.3821 37.4049C73.6646 37.3732 73.9299 37.2614 74.149 37.1178C74.4754 37.1057 74.7942 36.9939 74.9854 36.6917C76.2585 34.5995 75.5929 31.8621 73.5173 30.5859C72.3024 29.8462 70.8819 29.6256 69.5068 29.952C68.1301 30.2867 66.9726 31.1352 66.2329 32.3343C64.4067 35.3203 65.3489 39.2455 68.3507 41.0906C69.6042 41.8552 70.9862 42.2179 72.3454 42.2179C74.9416 42.2179 77.4772 40.907 78.9219 38.536C80.4625 36.0336 80.7088 33.4238 79.8006 30.932C82.4149 34.0381 83.6276 38.3252 83.0843 42.7521C82.6816 46.0509 81.0239 48.987 78.4089 51.0354C75.7954 53.0837 72.5373 53.9836 69.2544 53.5854C68.6552 53.4978 68.177 53.9164 68.1188 54.4785C68.041 55.0399 68.4497 55.5499 69.0171 55.6096C69.6133 55.6859 70.2049 55.7207 70.7958 55.7207C74.0077 55.7207 77.1153 54.6531 79.6858 52.6372C81.815 50.9674 83.3631 48.7687 84.2895 46.2859C86.1784 52.239 91.756 56.375 98.0635 56.375C98.646 56.375 99.2309 56.3395 99.8247 56.2715C100.391 56.199 100.781 55.6935 100.722 55.1396C100.654 54.5783 100.192 54.1597 99.5897 54.2466C92.8244 55.0913 86.5826 50.2148 85.7424 43.4132C85.2067 38.9826 86.4194 34.6955 89.0329 31.5969C88.121 34.085 88.3733 36.6992 89.9071 39.2009C91.3495 41.5719 93.8996 42.8783 96.4859 42.8783C97.8527 42.8783 99.2354 42.5163 100.482 41.7555C101.928 40.8624 102.949 39.4638 103.351 37.8144C103.749 36.1643 103.479 34.4514 102.59 33.009C101.849 31.8001 100.685 30.9554 99.3147 30.6207C97.9441 30.2867 96.5055 30.5111 95.3057 31.2546C94.294 31.8742 93.5852 32.8541 93.3094 34.0094C93.0306 35.1601 93.2218 36.3524 93.8436 37.3641C94.0265 37.6663 94.3453 37.7782 94.6725 37.7895C94.9037 37.9331 95.1545 38.0411 95.4417 38.0728C96.4942 38.2043 97.45 37.4593 97.5769 36.4076C97.6963 35.3551 96.9558 34.3955 95.9116 34.2678C95.7288 34.2436 95.5452 34.2799 95.3699 34.3116C95.5444 33.7699 95.8799 33.2999 96.374 32.9969C97.1069 32.5391 97.9834 32.3955 98.8364 32.6086C99.6812 32.8133 100.394 33.3316 100.844 34.0766C101.442 35.0611 101.629 36.2202 101.362 37.3392C101.092 38.4627 100.399 39.4193 99.4061 40.0252C96.745 41.6467 93.2535 40.8057 91.6366 38.1446C89.5248 34.7143 90.433 31.1065 94.1784 27.9845C94.1942 27.9724 94.1867 27.9528 94.2025 27.9444C95.6442 27.3846 97.1825 27.0302 98.8319 27.006C98.9241 27.006 99.0276 27.006 99.1273 27.006C108.26 27.006 113.188 33.7457 117.954 40.2678C119.093 41.8295 120.229 43.3717 121.401 44.8103C126.592 51.1895 131.107 56.6999 138.625 55.4532C141.633 54.9508 144.272 53.2817 146.041 50.7354C146.901 49.4887 147.487 48.0856 147.825 46.6161C148.511 46.9425 149.24 47.1261 149.997 47.1261C152.642 47.1261 154.957 45.0694 155.607 43.584C157.248 39.8643 157.248 36.2466 155.61 32.808ZM15.0612 33.0234C15.2327 32.6592 15.5092 32.332 15.7223 31.9814L20.8065 39.7608C20.5935 40.6735 20.4998 41.55 20.5073 42.3947L14.5308 35.4178C14.4567 35.3384 14.3593 35.3422 14.2777 35.2863C14.4537 34.5292 14.7106 33.7721 15.0612 33.0234ZM22.765 43.7139C22.7227 42.9485 22.7567 42.1877 22.8942 41.4314C22.9403 41.2039 22.8624 40.9931 22.765 40.802L36.1385 40.8934C36.1068 42.0887 35.9096 43.0566 35.6172 43.9255L22.765 43.7139ZM27.0604 31.3196L34.8299 30.8096C34.8934 31.2357 34.9636 31.6384 35.0528 32.0351C35.154 32.5851 35.2364 33.0468 35.3218 33.5568L25.4246 33.927C25.9346 33.0634 26.4809 32.1907 27.0604 31.3196ZM30.6146 26.4832L34.6093 26.2897C34.5594 27.1919 34.5692 28.017 34.6168 28.7839L28.5625 29.1821C29.2281 28.2565 29.9134 27.3596 30.6146 26.4832ZM34.8004 24.2376L32.3577 24.3547C33.4094 23.108 34.437 21.952 35.392 20.9199C35.1193 22.1318 34.9349 23.2221 34.8004 24.2376ZM30.8677 22.9569L31.015 20.7575C32.0048 20.3366 32.9568 19.9626 33.7978 19.6513C32.9274 20.5935 31.9376 21.7034 30.8677 22.9569ZM28.7173 25.5765C28.1295 26.3192 27.5462 27.0944 26.9705 27.8779L26.2731 23.0302C27.1677 22.5519 28.0479 22.1039 28.9085 21.7034L28.6592 25.4337C28.6599 25.4903 28.7173 25.5266 28.7173 25.5765ZM25.2652 30.3419C24.8367 30.9954 24.4083 31.6505 24.0117 32.3124L21.7329 25.9429C21.711 25.9029 21.6671 25.8953 21.6467 25.8576C22.5232 25.2342 23.4337 24.6539 24.3502 24.1046L25.2652 30.3419ZM24.3109 36.0154L35.7064 35.5855C35.89 36.7929 36.0033 37.8605 36.0728 38.8488L23.1632 38.7612C23.4661 37.8764 23.8409 36.9554 24.3109 36.0154ZM31.9451 47.8333C30.672 48.4309 29.4767 48.7377 28.3834 48.7377C25.8651 48.7377 24.3109 47.1125 23.4427 45.7691L34.5352 45.9481C33.8734 46.7135 33.0211 47.3233 31.9451 47.8333ZM20.0019 27.1466L22.6992 34.697C22.2708 35.5455 21.9044 36.3902 21.5855 37.2228L16.9418 30.1243C17.8205 29.0566 18.8761 28.0767 20.0019 27.1466ZM15.0808 42.0879C14.4771 40.7007 14.1764 39.3588 14.0948 38.0434L19.4518 44.2942C19.2387 44.3418 19.0393 44.4098 18.8262 44.4098C17.043 44.4143 15.442 42.9002 15.0808 42.0879ZM133.214 44.5866C132.927 43.7215 132.724 42.7536 132.693 41.5583L146.064 41.4661C145.968 41.6573 145.889 41.8688 145.936 42.0955C146.08 42.8526 146.108 43.618 146.072 44.3788L133.214 44.5866ZM140.278 29.8356L134.217 29.439C134.261 28.6721 134.273 27.8492 134.226 26.9471L138.222 27.1382C138.916 28.0208 139.609 28.9214 140.278 29.8356ZM143.402 34.5889L133.497 34.2187C133.584 33.7087 133.664 33.2463 133.775 32.6962C133.859 32.3003 133.923 31.8915 133.999 31.4707L141.769 31.9807C142.354 32.8519 142.9 33.7245 143.402 34.5889ZM144.526 36.6766C144.987 37.6089 145.37 38.5337 145.673 39.4223L132.755 39.5099C132.827 38.5217 132.938 37.454 133.13 36.2429L144.526 36.6766ZM143.57 31.0068L144.47 24.7635C145.398 25.3113 146.299 25.8916 147.175 26.5187C147.156 26.5549 147.111 26.5663 147.092 26.6041L144.805 32.9712C144.422 32.3124 144 31.6588 143.57 31.0068ZM141.864 28.5466C141.29 27.7593 140.705 26.9886 140.118 26.2452C140.118 26.1915 140.174 26.156 140.17 26.1024L139.919 22.3691C140.787 22.7733 141.664 23.2176 142.553 23.7004L141.864 28.5466ZM137.964 23.618C136.9 22.3653 135.903 21.2516 135.035 20.3132C135.871 20.6237 136.823 20.9985 137.816 21.4186L137.964 23.618ZM136.481 25.0166L134.035 24.8987C133.903 23.8825 133.716 22.793 133.442 21.5856C134.393 22.6139 135.422 23.7692 136.481 25.0166ZM148.327 43.0596C148.335 42.2194 148.244 41.3384 148.028 40.4264L153.108 32.6471C153.327 32.9992 153.598 33.3226 153.77 33.6853C154.124 34.434 154.384 35.1956 154.551 35.9527C154.463 36.0079 154.368 36.0041 154.295 36.0797L148.327 43.0596ZM151.889 30.7861L147.251 37.8847C146.932 37.0483 146.558 36.2066 146.132 35.3543L148.829 27.8077C149.961 28.7378 151.012 29.7185 151.889 30.7861ZM136.883 48.4914C135.807 47.9852 134.939 47.3792 134.293 46.6108L145.378 46.4317C144.51 47.7698 142.947 49.4041 140.453 49.4041C139.37 49.395 138.166 49.0928 136.883 48.4914ZM150.004 45.0762C149.793 45.0762 149.586 44.9999 149.383 44.9606L154.738 38.7166C154.654 40.0313 154.363 41.3709 153.762 42.7536C153.387 43.5621 151.797 45.0762 150.004 45.0762Z\" fill=\"currentColor\"/></svg>");
var divider = /* #__PURE__ */ Specular_Dom_Element.rawHtml("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 7L7 10C7 10.55 7.45 11 8 11C8.55 11 9 10.55 9 10L9 7C9 5.35 10.35 4 12 4C13.65 4 15 5.35 15 7L15 10C15 10.55 15.45 11 16 11C16.55 11 17 10.55 17 10L17 7C17 4.24 14.76 2 12 2C9.24 2 7 4.24 7 7ZM12 16C12.55 16 13 15.55 13 15L13 9C13 8.45 12.55 8 12 8C11.45 8 11 8.45 11 9L11 15C11 15.55 11.45 16 12 16ZM15 14L15 17C15 18.65 13.65 20 12 20C10.35 20 9 18.65 9 17L9 14C9 13.45 8.55 13 8 13C7.45 13 7 13.45 7 14L7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17L17 14C17 13.45 16.55 13 16 13C15.45 13 15 13.45 15 14Z\" fill=\"currentColor\"/></svg>");
var description = function (v) {
    return v.value0;
};
var $$delete = /* #__PURE__ */ (function () {
    return new MDIcon("delete");
})();
var createNewFolder = /* #__PURE__ */ (function () {
    return new MDIcon("create_new_folder");
})();
var contentCopy = /* #__PURE__ */ (function () {
    return new MDIcon("content_copy");
})();
var contactSupport = /* #__PURE__ */ (function () {
    return new MDIcon("contact_support");
})();
var code = /* #__PURE__ */ (function () {
    return new MDIcon("code");
})();
var closeFullscreen = /* #__PURE__ */ (function () {
    return new MDIcon("close_fullscreen");
})();
var close = /* #__PURE__ */ (function () {
    return new MDIcon("close");
})();
var clear = /* #__PURE__ */ (function () {
    return new MDIcon("clear");
})();
var checkboxOutline = /* #__PURE__ */ (function () {
    return new MDIcon("check_box_outline_blank");
})();
var checkbox = /* #__PURE__ */ (function () {
    return new MDIcon("check_box");
})();
var checkCircleOutline = /* #__PURE__ */ (function () {
    return new MDIcon("check_circle_outline");
})();
var checkCircle = /* #__PURE__ */ (function () {
    return new MDIcon("check_circle");
})();
var check = /* #__PURE__ */ (function () {
    return new MDIcon("check");
})();
var cancel = /* #__PURE__ */ (function () {
    return new MDIcon("cancel");
})();
var campaign = /* #__PURE__ */ (function () {
    return new MDIcon("campaign");
})();
var call = /* #__PURE__ */ (function () {
    return new MDIcon("call");
})();
var build = /* #__PURE__ */ (function () {
    return new MDIcon("build");
})();
var bookmark = /* #__PURE__ */ (function () {
    return new MDIcon("bookmark");
})();
var block = /* #__PURE__ */ (function () {
    return new MDIcon("block");
})();
var barChart = /* #__PURE__ */ (function () {
    return new MDIcon("bar_chart");
})();
var attachMoney = /* #__PURE__ */ (function () {
    return new MDIcon("attach_money");
})();
var arrowRight = /* #__PURE__ */ (function () {
    return new MDIcon("arrow_right");
})();
var arrowDropDown = /* #__PURE__ */ (function () {
    return new MDIcon("arrow_drop_down");
})();
var arrowBack = /* #__PURE__ */ (function () {
    return new MDIcon("arrow_back");
})();
var addCircleOutline = /* #__PURE__ */ (function () {
    return new MDIcon("add_circle_outline");
})();
var addCircle = /* #__PURE__ */ (function () {
    return new MDIcon("add_circle");
})();
var add = /* #__PURE__ */ (function () {
    return new MDIcon("add");
})();
export {
    MDIcon,
    description,
    download,
    error,
    settings,
    questionMark,
    edit,
    orderApprove,
    pointOfSale,
    shoppingBasket,
    shoppingCart,
    removeShoppingCart,
    add,
    addCircle,
    addCircleOutline,
    remove,
    clear,
    removeCircle,
    removeCircleOutline,
    sell,
    visibility,
    visibilityOff,
    search,
    filter,
    help,
    moreVert,
    createNewFolder,
    insertPhoto,
    dragIndicator,
    check,
    checkCircle,
    checkCircleOutline,
    timerOff,
    done,
    refresh,
    block,
    cancel,
    code,
    expandLess,
    expandMore,
    checkbox,
    checkboxOutline,
    openInFull,
    closeFullscreen,
    close,
    arrowBack,
    arrowRight,
    arrowDropDown,
    localShipping,
    incompleteCircle,
    payments,
    rateReview,
    undo,
    redo,
    exportNotes,
    barChart,
    info,
    mobileOff,
    lightbulb,
    contactSupport,
    bookmark,
    build,
    notifications,
    campaign,
    star,
    call,
    mail,
    showChart,
    offlineBolt,
    attachMoney,
    contentCopy,
    person,
    fullscreen,
    polyline,
    panTool,
    $$delete as delete,
    select,
    moped,
    homePin,
    lockOpen,
    takeoutDining,
    md14,
    md18,
    md24,
    md36,
    md48,
    fill,
    separator,
    divider,
    dividerSpecial,
    house
};
